import { useMutation } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import type { PresignUploadInput, PresignedUploadResponse } from '@shared/validation/upload-schemas';
import { toast } from '../components/ui/Toast';

export function usePresignUpload() {
  return useMutation({
    mutationFn: async (data: PresignUploadInput) => {
      const response = await api.post<{ data: PresignedUploadResponse }>('/uploads/presign', data);
      return response.data.data;
    },
  });
}

export function useUploadToS3() {
  return useMutation({
    mutationFn: async ({
      uploadUrl,
      file,
      contentType,
    }: {
      uploadUrl: string;
      file: File | Blob;
      contentType: string;
    }) => {
      const response = await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: { 'Content-Type': contentType },
      });
      if (!response.ok) {
        throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
      }
    },
  });
}

export function useDeleteUpload() {
  return useMutation({
    mutationFn: async (s3Key: string) => {
      const response = await api.delete<{ data: { deleted: boolean } }>(
        '/uploads/delete',
        { params: { key: s3Key } },
      );
      return response.data.data;
    },
    onSuccess: () => {
      toast('success', 'Archivo eliminado');
    },
    onError: () => {
      toast('error', 'Error al eliminar el archivo');
    },
  });
}

export function useGetDownloadUrl() {
  return useMutation({
    mutationFn: async (s3Key: string) => {
      const response = await api.get<{ data: { download_url: string; expires_in: number } }>(
        '/uploads/download',
        { params: { key: s3Key } },
      );
      return response.data.data;
    },
  });
}
